import React from 'react';
import styles from './link-grid-widget.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { QgendaLogo } from 'src/images/ui';
import { GridItemsNavigator } from 'src/components/common/items-navigator';
import { Tooltip } from 'src/components/core';
import { useAnalyticsImpression } from 'src/hooks/analytics/use-analytics-impression';

export function LinkGridWidget({
  title = '',
  list,
  defaultIcon = QgendaLogo,
  impressionEvent = null,
  trackAnalytics,
}) {
  const lang = useSelector(getLang('PROFILE_OPTIONS'));
  const { ref } = useAnalyticsImpression({ event: impressionEvent });

  if (!list || list.length === 0) {
    return null;
  }

  const renderList = (item, index) => {
    const title =
      item.title ||
      [...item?.roles, ...item?.professions].map(i => lang[i]).join(', ') ||
      'Default';

    return (
      <Tooltip title={title} key={`${item.url}-${index}`}>
        <a
          className={styles.linkItem}
          href={item.url}
          target="_blank"
          rel="noreferrer"
          onClick={() => trackAnalytics?.(item.url, title)}>
          <img src={item?.iconUrl || defaultIcon} alt="" />
          <span>{title}</span>
        </a>
      </Tooltip>
    );
  };

  return (
    <>
      <label className={styles.title}>{title}</label>
      <GridItemsNavigator columns={4} aria-label={title}>
        <div className={styles.listMap} ref={ref}>
          {list.map(renderList)}
        </div>
      </GridItemsNavigator>
    </>
  );
}
